import { Component } from '@angular/core';

@Component({
    selector: 'app-admin-home-assets',
    templateUrl: './admin-home-assets.component.html',
    styleUrls: ['./admin-home-assets.component.sass'],
    standalone: false
})
export class AdminHomeAssetsComponent {
}
